import { Button, makeStyles } from '@material-ui/core';
import FolderTree from 'components/molecules/gallery/FolderTree';
import ImagesBlock from 'components/molecules/gallery/ImagesBlock';
import { GalleryContext } from 'context/gallery/GalleryContext';
import React, { useContext } from 'react';

const useStyles = makeStyles(() => ({
    gallery: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
    },
    galleryButton: {
        margin: '30px 0 30px auto',
        display: 'block',
        backgroundColor: 'orange',
    },
}));

const GalleryContent = () => {
    const classes = useStyles();
    const { state, setGalleryState } = useContext(GalleryContext);
    return (
        <section className={classes.gallery}>
            {!state.openGallery && (
                <React.Fragment>
                    <div>
                        <FolderTree />
                    </div>
                    <div>
                        <Button
                            onClick={() => setGalleryState({ ...state, isUploading: !state.isUploading })}
                            variant='contained'
                            className={classes.galleryButton}
                        >
                            {state.isUploading ? 'Close' : 'Upload media'}
                        </Button>
                        <ImagesBlock />
                    </div>
                </React.Fragment>
            )}
        </section>
    );
};

export default GalleryContent;
